const getEditPositionFillRequestValidation = (isActive: boolean) => ({
  ownerAlias: { type: 'string', required: true },
  recruitmentPoolId: { type: 'string', required: false },
  positionSlotId: {
    type: 'string',
    required: true,
  },

  // Replacing by the date in the mapper (expirationDate)
  expirationPeriodInMonth: {
    type: 'enum',
    required: true,
  },
  responsibilities: {
    type: 'string',
    required: true,
  },

  requiredExperience: {
    type: 'number',
    required: true,
    minValue: 0,
  },
  englishLevel: {
    type: 'enum',
    required: true,
  },
  requirements: {
    type: 'string',
    required: true,
  },

  projectName: {
    type: 'string',
    required: {
      value: true,
      when: {
        $projectDescription: {
          notEmpty: true,
        },
      },
    },
  },
  projectDescription: { type: 'string', required: false },

  notes: {
    type: 'string',
    required: false,
  },
});

export default getEditPositionFillRequestValidation;
